import PropTypes from 'prop-types';
import React, { useState } from 'react';
import { Modal, Button } from 'react-bootstrap';

const BulkApprovalModal = ({ show, onHide, onConfirm, selectedItems, loader }) => {
  const [comments, setComments] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSubmit = async () => {
    setIsSubmitting(true);
    try {
      await onConfirm(comments);
      setComments('');
    } catch (error) {
      console.error('Error submitting bulk approval:', error);
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleClose = () => {
    setComments('');
    onHide();
  };

  const getModalTitle = () => {
    return `Bulk Approve Package Assignments`;
  };

  return (
    <Modal show={show} onHide={handleClose} centered size="xl" className='modalDeleteWrapper '>
      <Modal.Header closeButton>
        <Modal.Title>{getModalTitle()}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="mb-3">
          <div className="alert alert-info">
            <strong>You are about to approve {selectedItems?.length || 0} package assignment(s).</strong>
          </div>
        </div>

        {selectedItems && selectedItems.length > 0 && (
          <div className="main_content_table_history" style={{ maxHeight: '300px', overflowY: 'auto' }}>
            <div className="incomingTbl">
              <table className="tableWide table-height cus-left-right-col-layout  table">
                <thead>
                  <tr>
                    <th>Thumbnail</th>
                    <th className='taskTitle'>To Company/Seller</th>
                    <th>Carrier</th>
                    <th>Source</th>
                    <th className='taskTitle'>Tracking Number</th>
                  </tr>
                </thead>
                <tbody>
                  {selectedItems.map((item, index) => (
                    <tr key={item.id || index}>
                      <td><img src={item.thumbnailUrl} alt="Thumbnail" style={{ maxWidth: '50px', maxHeight: '50px' }} /></td>
                      <td className='taskTitle'>{item.companySellerName}</td>
                      <td>{item.carrierName}</td>
                      <td>{item.source}</td>
                      <td className='taskTitle'>{item.trackingNumber}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        )}

        <div className="alert alert-warning mt-3">
          <strong>Warning:</strong> This action cannot be undone. All selected package assignments will be approved.
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={handleClose} disabled={isSubmitting}>
          Cancel
        </Button>
        <Button
          variant="success"
          onClick={handleSubmit}
          disabled={loader}
        >
          Approve
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

BulkApprovalModal.propTypes = {
  show: PropTypes.bool.isRequired,
  onHide: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
  selectedItems: PropTypes.array.isRequired,
  loader: PropTypes.bool
};

export default BulkApprovalModal;